__turbopack_context__.v({
  "signupButtonText": "page-module__zMhrWG__signupButtonText",
  "signupContainer": "page-module__zMhrWG__signupContainer",
  "signupDividerText": "page-module__zMhrWG__signupDividerText",
  "signupErrorText": "page-module__zMhrWG__signupErrorText",
  "signupHelperText": "page-module__zMhrWG__signupHelperText",
  "signupInputText": "page-module__zMhrWG__signupInputText",
  "signupLabelText": "page-module__zMhrWG__signupLabelText",
  "signupLinkText": "page-module__zMhrWG__signupLinkText",
  "signupPromoText": "page-module__zMhrWG__signupPromoText",
  "signupSubtitle": "page-module__zMhrWG__signupSubtitle",
  "signupTermsText": "page-module__zMhrWG__signupTermsText",
  "signupTitle": "page-module__zMhrWG__signupTitle",
});
